import { Col, Row } from 'react-bootstrap';
import '../styles/Stats.css';

const Stats = ({ statsData, numberOfColumn = 3 }) => {
  const isFiveCols = statsData?.length === 5;
  return (
    <div className={`stats_main_div ${isFiveCols ? 'stats_five_cols_container' : ''}`}>
      <Row className={isFiveCols ? 'stats_five_cols_row' : ''}>
        {
          statsData?.map((stat, index) => (
            <Col 
              md={isFiveCols ? undefined : numberOfColumn} 
              className={isFiveCols ? 'col-stats-five' : ''} 
              key={index}
            >
              <div className='stats_card'>
                <div>
                  <h6>{stat.title}</h6>
                  <div className={stat.className}>{stat.value}</div>
                  <p>{stat.text}</p>
                </div>
                <span>{stat.icon}</span>
              </div>
            </Col>
          ))
        }
      </Row>
    </div>
  )
}

export default Stats;